import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MellonService} from "../mellon.service";
import { Location, isPlatformBrowser } from '@angular/common';
import {  Inject, PLATFORM_ID } from '@angular/core';

declare var MobileDetect;



@Component({
  selector: 'register-button',
  templateUrl: './register-button.component.html'
})
export class RegisterButtonComponent implements OnInit {
  env = environment;
  isMobile = false;
  isAndroid = false;
  isIOs= false;
  isWebGLSupported=false;

  constructor(private mellonService: MellonService, @Inject(PLATFORM_ID) private platform: any) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platform)) {
      console.log("Register Button");
      var md = new MobileDetect(window.navigator.userAgent);
      this.isMobile = md.mobile() != null;
      this.isAndroid = md.os() == 'AndroidOS';
      this.isIOs = ((md.os() == 'iOS') || (md.os() == 'iPadOS'));
      this.isWebGLSupported = this.testWebglSupport();
    }
  }

  testWebglSupport():boolean {
      try {
        var canvas = document.createElement('canvas');

        if(!!(window as any).WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')))  {
          return true;
        } else {
          return false;
        }
      } catch(e) {
        return false;
      }
  }

}
